import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {GetUser, GetUserError, GetUserComplete, PostUser, PostUserError, PostUserComplete, UserActionTypes} from '../actions/user.actions';
import {catchError, exhaustMap, map, tap} from 'rxjs/operators';
import {of} from 'rxjs';
import {HttpErrorResponse} from '@angular/common/http';
import {GetUserRequest, PostUserRequest, User} from '../models/user';
import {UserService} from '../services/user.service';

@Injectable()
export class UserEffects {

  @Effect()
  getUser$ = this.actions$.pipe(
    ofType(UserActionTypes.GetUser),
    map((action: GetUser) => action.payload),
    exhaustMap((getUserRequest: GetUserRequest) =>
      this.userService.getUser(getUserRequest)
        .pipe(
          tap((user: User) => {
            if ((<any>window).Appcues != null) {
              (<any>window).Appcues.identify(user.id.toString(), {
                email: user.email,
                name: `${user.firstName} ${user.lastName}`
              });
            }
          }),
          map((user: User) => new GetUserComplete(user)),
          catchError((error: HttpErrorResponse) => of(new GetUserError({
            errorMessage: error.message
          })))
        )
    )
  );

  @Effect()
  postUser$ = this.actions$.pipe(
    ofType(UserActionTypes.PostUser),
    map((action: PostUser) => action.payload),
    exhaustMap((postUserRequest: PostUserRequest) =>
      this.userService.postUser(postUserRequest)
        .pipe(
          map((response: { message: string }) => new PostUserComplete()),
          catchError((error: HttpErrorResponse) => of(new PostUserError({
            errorMessage: this.getPostUserErrorMessage(error)
          })))
        )
    )
  );

  constructor(private actions$: Actions,
              private userService: UserService) {
  }

  private getPostUserErrorMessage(error: HttpErrorResponse): string {
    const errorMessageMap = {
      0: 'No response from the server. Please try again later',
      422: 'Organization name already exists'
    };

    return errorMessageMap[error.status] || 'Failed to create user.\nPlease try again later';
  }
}
